<template>
  <div class="popup-full  partner-register-popup">
    <div class="popup-full__wrap">
      <button type="button"
              class="popup-full__close"
              @click="close">
        <BaseSvg name="ico-close"/>
      </button>

      <div class="popup-full__scroll">
        <div class="popup-full__content  partner-register-popup__content">
          <BasePreloader v-if="pending"/>

          <div class="partner-register-popup__title">
            {{ $tPartnersRegisterPopup('title') }}
          </div>

          <BaseInput :label="$tPartnersRegisterPopup('input_full_name')"
                     v-model="inputs.fio.value"
                     :error="inputs.fio.error"
                     class="partner-register-popup__input"/>
          <BaseInput :label="$tPartnersRegisterPopup('input_login')"
                     :sub="`(${inputs.login.charactersQuantity} ${$tPartnersRegisterPopup('input_characters')})`"
                     v-model="inputs.login.value"
                     :error="inputs.login.error"
                     autocomplete="new-password"
                     v-mask="getMaskCharactersQuantity(inputs.login.charactersQuantity)"
                     class="partner-register-popup__input"/>
          <BaseInput :label="$tPartnersRegisterPopup('input_password')"
                     :sub="`(${inputs.password.charactersQuantity} ${$tPartnersRegisterPopup('input_characters')})`"
                     v-model="inputs.password.value"
                     :error="inputs.password.error"
                     type="password"
                     autocomplete="new-password"
                     v-mask="getMaskCharactersQuantity(inputs.password.charactersQuantity)"
                     class="partner-register-popup__input"/>

          <BaseAlert :value="overallErrorsMix"
                     class="partner-register-popup__error  _warning"/>

          <button @click.prevent="send"
                  class="partner-register-popup__btn  base-btn  base-btn--green">
            {{ $tPartnersRegisterPopup('register_btn') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  import formMixins from '@/mixins/formMixins'

  export default {
    name: 'PartnersRegisterPopup',
    mixins: [formMixins],
    components: {},
    props: {
      callBack: Function
    },
    data() {
      return {
        pending: false,

        inputs: {
          fio: {
            value: null
          },
          login: {
            value: null,
            charactersQuantity: 12,
          },
          password: {
            value: null,
            charactersQuantity: 8,
          }
        }
      }
    },
    computed: {},
    methods: {
      close() {
        this.$emit('close')
      },
      send() {
        this.pending = true
        this.resetErrorsMix(this.inputs)

        const sendForm = this.createSendDataMix(this.inputs)

        http.post('/api/cabinet/agent/register-agent', sendForm)
          .then(({data}) => {
            this.callBack()
            this.$emit('open-agent-registered-show', this.$get(data.data, 'customer_data.id'))
            this.close()
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      },
      getMaskCharactersQuantity(quantity) {
        let a = ''

        for (let i = 0; i < quantity; i++) {
          a += 'X?'
        }

        return a
      }
    },
    created() {
      blockScroll()
    },
    beforeDestroy() {
      unBlockScroll()
    }
  }
</script>
